import $ from 'jquery';

export class Preloader {
    constructor(element) {
        this.element = element;
    }

    showPreloader() {
        $(this.element).addClass('form--loading');
    }

    hidePreloader() {
        $(this.element).removeClass('form--loading');
    }

    togglePreloader() {
        $(this.element).toggleClass('form--loading');
    }
}
